import { c as _c } from "react/compiler-runtime";
import { getAnalytics } from '../lib/utils';
import type { ProductCardEntrypointProps } from '../model/types';
import { ProductCard } from './Content';
export const ProductCardEntrypoint = t0 => {
  const $ = _c(16);
  const {
    analytics,
    creditCardOffer,
    driverGroup,
    initiallyExpandedAccordion,
    showSkeleton,
    slug,
    shouldPrioritizeImage: t1,
    isLtoHighlightingEnabled: t2,
    trafficOriginType,
    hideOuterBorder
  } = t0;
  const shouldPrioritizeImage = t1 === undefined ? false : t1;
  const isLtoHighlightingEnabled = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== analytics || $[1] !== creditCardOffer) {
    t3 = getAnalytics(analytics, creditCardOffer, "roundup_recommendations");
    $[0] = analytics;
    $[1] = creditCardOffer;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    ctaAnalytics,
    skuViewedProps,
    marketplacePayload
  } = t3;
  let t4;
  if ($[3] !== creditCardOffer || $[4] !== ctaAnalytics || $[5] !== driverGroup || $[6] !== hideOuterBorder || $[7] !== initiallyExpandedAccordion || $[8] !== isLtoHighlightingEnabled || $[9] !== marketplacePayload || $[10] !== shouldPrioritizeImage || $[11] !== showSkeleton || $[12] !== skuViewedProps || $[13] !== slug || $[14] !== trafficOriginType) {
    t4 = <div data-pc-layout="responsive"><ProductCard ctaAnalytics={ctaAnalytics} creditCardOffer={creditCardOffer} driverGroup={driverGroup} entityName="roundup_recommendations_card" marketplacePayload={marketplacePayload} initiallyExpandedAccordion={initiallyExpandedAccordion} showSkeleton={showSkeleton} skuViewedProps={skuViewedProps} slug={slug} shouldPrioritizeImage={shouldPrioritizeImage} isLtoHighlightingEnabled={isLtoHighlightingEnabled} trafficOriginType={trafficOriginType} hideOuterBorder={hideOuterBorder} /></div>;
    $[3] = creditCardOffer;
    $[4] = ctaAnalytics;
    $[5] = driverGroup;
    $[6] = hideOuterBorder;
    $[7] = initiallyExpandedAccordion;
    $[8] = isLtoHighlightingEnabled;
    $[9] = marketplacePayload;
    $[10] = shouldPrioritizeImage;
    $[11] = showSkeleton;
    $[12] = skuViewedProps;
    $[13] = slug;
    $[14] = trafficOriginType;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};